import * as AxlePermitFields from '@src/permitField/AxleInformationFields';
import { BooleanField } from '@src/permitField/PermitFields';

export class AxleSpacingField extends BooleanField {
  public static fieldName: string = AxlePermitFields.AxleSpacingField.fieldName;
}

export class AxleWeightField extends BooleanField {
  public static fieldName: string = AxlePermitFields.AxleWeightField.fieldName;
}

export class AxleWidthField extends BooleanField {
  public static fieldName: string = AxlePermitFields.AxleWidthField.fieldName;
}

export class AxleCapacityField extends BooleanField {
  public static fieldName: string =
    AxlePermitFields.AxleCapacityField.fieldName;
}

export class TireCountField extends BooleanField {
  public static fieldName: string = AxlePermitFields.TireCountField.fieldName;
}

export class TireRatingField extends BooleanField {
  public static fieldName: string = AxlePermitFields.TireRatingField.fieldName;
}

export class TireSizeField extends BooleanField {
  public static fieldName: string = AxlePermitFields.TireSizeField.fieldName;
}

export class SuspensionField extends BooleanField {
  public static fieldName: string =
    AxlePermitFields.SuspensionTypeField.fieldName;
}

export class IsSteeringAxleField extends BooleanField {
  public static fieldName: string =
    AxlePermitFields.IsSteeringAxleField.fieldName;
}

export class AxleGroupField extends BooleanField {
  public static fieldName: string = AxlePermitFields.AxleGroupField.fieldName;
}
export class AxleTypeField extends BooleanField {
  public static fieldName: string = AxlePermitFields.AxleTypeField.fieldName;
}
